import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Message } from 'primeng/api';
import { CustoMedio } from 'src/app/admihair/api/dto/custo-medio';
import { ItemProdutoVw } from 'src/app/admihair/api/dto/item-produto-vw';
import { CustoService } from 'src/app/admihair/service/custo.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { ItemProdutoService } from 'src/app/admihair/service/item-produto.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { EntradaEstoqueService } from 'src/app/admihair/service/entrada-estoque.service';

@Component({
  selector: 'app-item-produto-detalhar',
  templateUrl: './item-produto-detalhar.component.html',
  styleUrls: ['./item-produto-detalhar.component.scss']
})
export class ItemProdutoDetalharComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('f') form?: NgForm;
  id?: number;
  itemProdutoVw?: ItemProdutoVw;
  loading: boolean = true;
  urlDetalheProduto: string = '';

  exibirDialogValorSugerido: boolean = false;
  custoMedio: CustoMedio = {
    custoFixo: 0,
    imposto: 0
  };
  percentualFrete: number = 0;
  valorVenda: number = 0;
  valorLucroDesejado: number = 0;
  valorLucroObtido: number = 0;
  valorSugerido: number = 0;
  novoValor: number = 0;
  valorLucroObtidoAtual: number = 0;
  loadingSpinnerDialog: boolean = false;

  constructor(
    private itemProdutoService: ItemProdutoService,
    private custoService: CustoService,
    private entradaEstoqueService: EntradaEstoqueService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router?: Router,
    route?: ActivatedRoute) {
    super(erroService, storageService, router, route)
  }


  ngOnInit(): void {
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_PRODUTO');
    this.carregarIdUrl();
    if (this.permissaoDetalhar) {
      this.carregarItemProdutoPorId();
    }
  }


  carregarItemProdutoPorId() {
    this.itemProdutoService.buscarDadosItemProdutoPorId(this.idParametroUrl).subscribe({
      next: (data: ItemProdutoVw) => {
        this.itemProdutoVw = data;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  abrirUrlProduto() {
    window.open(this.itemProdutoVw?.urlDetalheProduto, '_blank');
  }

  abrirDialogValorSugerido() {
    this.exibirDialogValorSugerido = true;
    this.definirValoresPadrao();
    this.obterCustos();
  }


  definirValoresPadrao() {
    this.novoValor = 0;
    this.valorLucroDesejado = (this.itemProdutoVw?.valorCompra ?? 0) * ((this.itemProdutoVw?.lucro ?? 0) / 100);
    this.valorLucroObtido = 0;
    this.valorSugerido = 0;
  }

  obterCustos() {
    this.loadingSpinnerDialog = true;
    this.custoService.obterDadosParaPrecificacao(this.getEmpresa().id).subscribe({
      next: (data: CustoMedio) => {
        this.custoMedio = data;
        this.buscarPercentualFrete();
      },
      error: (err: any) => {
        this.loadingSpinnerDialog = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  buscarPercentualFrete() {
    this.entradaEstoqueService.buscarPercentualFreteUltimaEntrada(
      this.getEmpresa().id,
      this.itemProdutoVw?.id
    ).subscribe({
      next: (data: number) => {
        this.percentualFrete = data;
        this.calcularLucroObtidoAtual();
        this.calcularValorSugerido();
        this.loadingSpinnerDialog = false;
      },
      error: (err: any) => {
        this.loadingSpinnerDialog = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  private calcularValorCompra(): number {
    const valorCompra = this.itemProdutoVw?.valorCompra ?? 0;
    const quantidade = this.itemProdutoVw?.quantidadeUnidadeMedida ?? 1;

    if (quantidade > 1) {
      return valorCompra / quantidade;
    }
    return valorCompra;
  }

  private calcularValorFrete(valorCompra: number): number {
    return valorCompra * (this.percentualFrete / 100);
  }

  private calcularPercentualCusto(): number {
    const custoFixo = this.custoMedio?.custoFixo ?? 0;
    const comissao = this.itemProdutoVw?.comissaoVenda ?? 0;
    const imposto = this.custoMedio?.imposto ?? 0;
    return custoFixo + comissao + imposto;
  }

  calcularValorSugerido(): void {
    if (!this.itemProdutoVw?.lucro) {
      this.valorSugerido = 0;
      return;
    }

    const valorCompra = this.calcularValorCompra();
    const valorFrete = this.calcularValorFrete(valorCompra);
    const valorLucroDesejado = valorCompra * (this.itemProdutoVw.lucro / 100);
    const valorComposicao = valorCompra + valorFrete + valorLucroDesejado;

    const percentualCusto = this.calcularPercentualCusto();
    const valorInicial = valorComposicao + (percentualCusto * valorComposicao / 100);
    const diferencaComposicao = (valorInicial - valorComposicao) * (percentualCusto / 100);

    const valorCalculado = valorInicial + diferencaComposicao + (diferencaComposicao * percentualCusto / 100);
    this.valorSugerido = valorCalculado;
  }

  calcularLucroObtidoAtual(): void {
    const valorCompra = this.calcularValorCompra();
    const valorFrete = this.calcularValorFrete(valorCompra);
    const valorVenda = this.itemProdutoVw?.valorVenda ?? 0;
    const percentualCusto = this.calcularPercentualCusto();

    const valorCustoReais = valorVenda * (percentualCusto / 100);
    this.valorLucroObtidoAtual = valorVenda - valorCompra - valorFrete - valorCustoReais;
  }

  calcularLucroObtido(valor?: number): void {
    this.novoValor = valor ?? 0;

    if (this.novoValor <= 0) {
      this.valorLucroObtido = 0;
      return;
    }

    const valorCompra = this.calcularValorCompra();
    const valorFrete = this.calcularValorFrete(valorCompra);
    const percentualCusto = this.calcularPercentualCusto();

    const valorCustoReais = this.novoValor * (percentualCusto / 100);
    this.valorLucroObtido = this.novoValor - valorCompra - valorFrete - valorCustoReais;
  }

}
